/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { mergeQueryKeys, getBaseQueryKey } from "../utils/queryKeyHelpers";

// The Cities list and the restaurant form's Discover City dropdown.
const cityBaseKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.cities),
  getBaseQueryKey(Query_Keys.cities_dropdown)
);

export const cityMutationKeyGroups = {
  create: cityBaseKeys,
  // A rename shows on the restaurant edit overview.
  update: mergeQueryKeys(cityBaseKeys, getBaseQueryKey(Query_Keys.show_restaurant)),
  // Only a city with no restaurants can be deleted, so restaurant caches are unaffected.
  delete: cityBaseKeys,
};
